import { FaCheck } from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  InfoContainer,
  HorizontalLine,
  Row,
  TextRow,
  Column,
  Label,
  Title,
  SubTitle,
  InfoText,
  MoneyText,
  IconBox
} from './styles'

export default function Subscription ({
  data: subscription,
  style ={}
}) {
  const { plan } = subscription
  const discount = 20.00

  const renderStatus = () => {
    let color = '#777777'
    let text = ''

    switch (subscription.status) {
      case 'active':
        color = '#44CF6C'
        text = 'Ativa'
        break
      case 'canceled':
        color = '#FF3939'
        text = 'Cancelada'
        break
      default: text = subscription.status
    }

    return (
      <SubTitle style={{color}}>
        {text}
      </SubTitle>
    )
  }

  return (
    <Container style={style}>
      <Title>{plan.name}</Title>
      <Column>
        <Row style={{justifyContent: 'space-between'}}>
          <InfoText>
            <MoneyText value={subscription.num_users * discount}/>
            {` / mês`}
          </InfoText>
          <InfoText style={{marginBottom: -2}}>
            (Recorrente)
          </InfoText>
        </Row>
        <HorizontalLine/>
        <Column style={{padding: 0}}>
          <TextRow>
            <SubTitle>Número de colaboradores:</SubTitle>
            <InfoText>
              {subscription.num_users}
            </InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Data de início:</SubTitle>
            <InfoText>
              {DateTime.fromISO (subscription.start_at).toFormat ('dd/MM/yyyy')}
            </InfoText>
          </TextRow>
          <TextRow>
            <SubTitle>Status:</SubTitle>
            {renderStatus ()}
          </TextRow>
          {/* Só a assinatura da Asaas traz o boleto em aberto; a da Vindi manda por e-mail */}
          {subscription.payment_url && (
            <TextRow>
              <SubTitle>Boleto em aberto:</SubTitle>
              <InfoText>
                <a href={subscription.payment_url} target='_blank' rel='noopener noreferrer'>Abrir boleto</a>
              </InfoText>
            </TextRow>
          )}
          {subscription.status === 'canceled' && subscription.cancel_at && (
            <TextRow>
              <SubTitle>Data de cancelamento:</SubTitle>
              <InfoText>
                {DateTime.fromISO (subscription.cancel_at).toFormat ('dd/MM/yyyy')}
              </InfoText>
            </TextRow>
          )}
        </Column>
      </Column>
      <InfoContainer>
        {plan.description.split ('-').map ((item, index) => (
          <Row key={index}>
            {index > 0 && (
              <IconBox>
                <FaCheck color='#FFC100' size={14}/>
              </IconBox>
            )}
            <Label>{item}</Label>
          </Row>
        ))}
      </InfoContainer>
    </Container>
  )
}
